export default __webpack_public_path__ + "static/media/phone.7e45cbd4.svg";